<template>
  <InputText
    v-model:text="text"
    :filtro="filtro"
    @aplicarFiltro="aplicarFiltro"
    :path="path"
  />
</template>
<script>
import InputText from '../../components/InputText.vue';
import mixinFiltro from '../../mixins/mixinFiltro';
export default {
  emits: ['excluirFiltro'],
  props: {
    filtro: {
      type: Object,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  components: {
    InputText
  },
  mixins: [mixinFiltro]
}
</script>
